<template>
	<div class="homepage-container">
		<img class="bgIcon" src="../assets/BuyNow/iconN.png" />
		<div class="painterInfoBox">
			<div class="topInfoBox">
				<div class="avatarNameFansWorkNum">
					<img class="avatar" :src="painterInfo.avatar" v-if="painterInfo.avatar" />
					<img class="avatar" src="../assets/defaultAvatar.png" v-else />
					<div class="nameFansWorkNum">
						<div class="name">{{painterInfo.nickname ? painterInfo.nickname : ''}}</div>
						<div class="fansWorkNum">
							<div class="fans">{{painterInfo.fs_count ? painterInfo.fs_count : '0'}}粉丝</div>
							<div class="line"></div>
							<div class="workNum">{{painterInfo.work_count ? painterInfo.work_count : '0'}}作品</div>
						</div>
					</div>
				</div>
				<div class="menuBox">
					<div class="menuItem">
						<img src="../assets/WorkDetails/iconH.png" alt="" />
						沟通
					</div>
					<div class="menuItem" @click="huaGuanZhu">
						<img src="../assets/WorkDetails/iconG.png" alt="" />
						关注
					</div>
				</div>
			</div>
			<div class="descTitle">
				画师简介
				<div class="rightMenu">
					<div class="rightMenuItem" @click="copyLink">
						<img class="icon" src="../assets/BuyNow/iconM.png" />
						复制链接
					</div>
					<div class="rightMenuItem">
						<img class="icon" src="../assets/Home/report.png" />
						举报
					</div>
				</div>
			</div>
			<div class="desc">
				<div class="descItem">
					在线时间：{{painterInfo.hs_time ? painterInfo.hs_time : ''}}
				</div>
				<div class="descItem">
					偏好类型：{{painterInfo.hs_ph ? painterInfo.hs_ph : ''}}
				</div>
				<div class="descItem">
					不接类型：{{painterInfo.hs_bj ? painterInfo.hs_bj : ''}}
				</div>
				<div class="descItem">
					约稿须知：{{painterInfo.hs_yg ? painterInfo.hs_yg : ''}}
				</div>
			</div>
			<div class="rateBox">
				<div class="rateItem">
					{{painterInfo.zy_count ? painterInfo.zy_count : '0%'}}
					<div class="rateTitle">需求完成率</div>
				</div>
				<div class="line"></div>
				<div class="rateItem">
					{{painterInfo.zs_count ? painterInfo.zs_count : '0%'}}
					<div class="rateTitle">准时交稿率</div>
				</div>
				<div class="line"></div>
				<div class="rateItem">
					{{painterInfo.hp_count ? painterInfo.hp_count : '0%'}}
					<div class="rateTitle">作品好评率</div>
				</div>
				<div class="line"></div>
				<div class="rateItem">
					<div class="rates" v-if="painterInfo.xj_count">
						<img src="../assets/WorkDetails/iconI.png" v-for="(item,index) in painterInfo.xj_count"
							:key="index" />
						<img src="../assets/WorkDetails/iconJ.png" v-for="(item,index) in 3 - painterInfo.xj_count"
							:key="index" />
					</div>
					<div class="rateTitle">星级画师</div>
				</div>
			</div>
		</div>
		<div class="naviBarMenu">
			<div class="naviBarItem" :class="selIndex == 0 ? 'avtive' : 'normal' " @click="selIndex = 0;workList()">
				全部作品
			</div>
			<div class="naviBarItem" :class="selIndex == 1 ? 'avtive' : 'normal' " @click="selIndex = 1;commentList()">
				我要定制
			</div>
		</div>
		<div class="customizeBox" v-if="selIndex == 1">
			<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="定制须知：" prop="tip">
					<div class="tips">
						{{painterInfo.hs_dj ? painterInfo.hs_dj : ''}}
					</div>
				</el-form-item>
				<el-form-item label="需求：" prop="content">
					<div class="reportContent">
						<el-input v-model="ruleForm.content" type="textarea" maxlength="500"
							placeholder="请详细描述您的定制需求" />
						<div class="textNum">
							<span>{{ruleForm.content ? ruleForm.content.length : 0}}</span>/500
						</div>
					</div>
				</el-form-item>
				<el-form-item label="用途：" prop="yongtu">
					<el-select v-model="ruleForm.yongtu" class="inputBox" placeholder="请选择用途" clearable>
						<el-option v-for="item in yongtuOpts" :key="item.id" :label="item.title" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="上传参考：" prop="imgList">
					<div class="imgList">
						<div class="imgItem" v-for="(item,index) in imgList" :key="index">
							<img class="imgItemImg" :src="item" />
							<img class="delete" @click="imgList.splice(index, 1)" src="../assets/Feedback/delete.png" />
						</div>
						<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
							<img class="addImg" src="../assets/Feedback/addImg.png" />
							上传参考
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div class="userAgreementSubmit">
				<div class="agreement-container">
					<label class="agreement-label">
						<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="agreeTerms"
							@click="agreeTerms = false" />
						<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else
							@click="agreeTerms = true" />
						<span class="agreement-text">我已阅读并同意</span>
						<div class="agreement-link" @click="userBuy = true">《用户购买须知协议》</div>
					</label>
				</div>
				<button type="button" @click="submit('ruleForm')" class="register-btn">提交</button>
			</div>
		</div>
		<div class="tabsBox" v-if="selIndex == 1">
			<el-tabs v-model="activeName" @tab-click="commentList">
				<el-tab-pane :label="`全部（${allComment}）`" name="0"></el-tab-pane>
				<el-tab-pane :label="`满意 (${commentInfo.my_count ? commentInfo.my_count : 0})`" name="1"></el-tab-pane>
				<el-tab-pane :label="`一般 (${commentInfo.yb_count ? commentInfo.yb_count : 0})`" name="2"></el-tab-pane>
				<el-tab-pane :label="`不满意 (${commentInfo.bmy_count ? commentInfo.bmy_count : 0})`"
					name="3"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="commentBoxList" v-if="selIndex == 1">
			<div class="comment" v-for="(item,index) in commentData" :key="index">
				<div class="userInfoBox">
					<div class="userInfo">
						<img class="avatar" :src="item.avatar" />
						<div class="nameTimeIdentity">
							<div class="nameBox">
								{{item.user_nickname}}
							</div>
							<div class="timeIdentity">
								{{item.create_time}}
							</div>
						</div>
					</div>
				</div>
				<div class="commentContentBox">
					<div class="contentText">
						{{item.pj_content}}
					</div>
					<div class="imgList" v-if="item.pj_img">
						<el-image class="imgItem" :src="row" :preview-src-list="item.pj_img"
							v-for="(row,rowIndex) in item.pj_img" :key="rowIndex">
						</el-image>
					</div>
				</div>
				<!-- <div class="commentMenuBox">
					<div class="commentMenuItem">
						<img class="icon" src="../assets/Home/commentTwo.png" />
						23
					</div>
					<div class="commentMenuItem">
						<img class="icon" src="../assets/Home/like.png" />
						888
					</div>
				</div> -->
				<div class="commentCommentBox" v-if="false">
					<div class="commentComment">
						<div class="commentCommentUserInfoBox">
							<div class="commentCommentUserInfo">
								<img class="commentCommentUserInfoavatar" src="../assets/inMsg.png" />
								<div class="commentCommentUserInfoNameTime">
									<div class="commentCommentUserInfoName">
										废物小甜心
									</div>
									<div class="commentCommentUserInfoTimeReply">
										2025年8月18日8时12分
										<div class="reply" @click="replyComment">
											回复
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="commentCommentContentBox">
							AI 绘画的魅力，在于它既是工具，也是镜子 —— 你输入的每一个关键词，都是内心世界的投射。不必追求
							“完美作品”，享受从灵感迸发、指令输入到画面生成的全过程，本身就是一场奇妙的创作冒险。
						</div>
						<div class="lastCommentList">
							<div class="lastComment" v-for="(item, index) in data.slice(0, show ? data.length : 3)"
								:key="index">
								<div class="nameLastCommentContent">
									Bruce7889
									<div class="lastCommentContent">: 前几个月第一次看见照片还以为是兄妹</div>
								</div>
								<div class="lastCommentContentTime">
									2025年8月18日8时12分
								</div>
							</div>
							<div class="moreBox" v-if="data.length > 3" @click="toggleShow">
								<span v-if="!show">共{{ data.length }}条回复</span>
								<span v-else>收起</span>
								<img v-if="!show" class="downArrow" src="../assets/Home/downArrow.png" />
								<img v-else class="downArrow" src="../assets/Home/upArrow.png" />
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="lookAll">
					查看全部26条评论
					<img class="downTwoArrow" src="../assets/Home/downTwoArrow.png" />
				</div> -->
			</div>
		</div>
		<div class="workList" v-if="selIndex == 0">
			<div class="filterBox">
				<div class="filterItem">
					<div class="filterItemTitle">类型：</div>
					<div class="filterItemList">
						<div class="tip" :class="cid == '' ? 'active' : ''" @click="changeFilter('cid','')">全部</div>
						<div class="tip" :class="cid == item.id ? 'active' : ''" v-for="(item,index) in typeOpts"
							:key="index" @click="changeFilter('cid',item.id)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">用途：</div>
					<div class="filterItemList">
						<div class="tip" :class="yongtu == '' ? 'active' : ''" @click="changeFilter('yongtu','')">全部
						</div>
						<div class="tip" :class="yongtu == item.id ? 'active' : ''" v-for="(item,index) in yongtuOpts"
							:key="index" @click="changeFilter('yongtu',item.id)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">可购身份：</div>
					<div class="filterItemList">
						<div class="tip" :class="level == '' ? 'active' : ''" @click="changeFilter('level','')">全部</div>
						<div class="tip" :class="level == item.id ? 'active' : ''" v-for="(item,index) in levelOpts"
							:key="index" @click="changeFilter('level',item.id)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">图片属性：</div>
					<div class="filterItemList">
						<div class="tip" :class="shuxing == item.title ? 'active' : ''"
							v-for="(item,index) in imgAttributeOpts" :key="index"
							@click="changeFilter('shuxing',item.title)">
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">排列方式：</div>
					<div class="filterItemList">
						<div class="tip" :class="px == item.value ? 'active' : ''" v-for="(item,index) in sortOpts"
							:key="index" @click="changeFilter('px',item.value)">{{item.title}}</div>
					</div>
				</div>
			</div>
			<div class="officialList" v-if="workData.length">
				<OfficalItem class="officalItem" :showBuy="true" :data="item" v-for="(item,index) in workData"
					:key="index">
				</OfficalItem>
			</div>

			<!-- 分页控件 -->
			<PagePagination :currentPage="currentPage" :total="total" @current-change="onPageChange" />
		</div>
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
		<UserBuyAgreeDialog :show="userBuy" @close="userBuy = false" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'"
			:subTitle="'您的定制需求已成功提交画师快跟画师沟通详细定制费用吧'" :btnTitle="'立即沟通'" @clickOk="sucPop = false" v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import OfficalItem from '../components/OfficalItem.vue'
	import PagePagination from '../components/PagePagination.vue'
	import UserBuyAgreeDialog from '../components/UserBuyAgreeDialog.vue'
	export default {
		name: 'PainterHomepage',
		components: {
			PopToast,
			OfficalItem,
			PagePagination,
			UserBuyAgreeDialog
		},
		data() {
			return {
				sucPop: false,
				userBuy: false,
				imgList: [],
				commentInfo: {},
				shuxing: '默认',
				imgAttributeOpts: [{
					title: '默认',
					value: '0'
				}, {
					title: '精品图',
					value: '1'
				}, {
					title: '普通图',
					value: '2'
				}],
				px: '',
				sortOpts: [{
					title: '默认',
					value: ''
				}, {
					title: '最新发布',
					value: '1'
				}, {
					title: '最多点赞',
					value: '2'
				}, {
					title: '价格升序',
					value: '3'
				}, {
					title: '价格降序',
					value: '4'
				}, {
					title: '综合排序',
					value: '5'
				}],
				cid: '', //分类
				typeOpts: [],
				yongtu: '', //用途
				level: '',
				levelOpts: [],
				selIndex: 0,
				painterInfo: {}, //画师信息
				workData: [], //画师作品
				commentData: [], //评论
				yongtuOpts: [], //定制用途
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				artworks: [{
						id: 1,
						title: '山水意境',
						artist: '东方水墨',
						image: 'https://picsum.photos/id/1/600/400',
						views: 3200,
						likes: 850
					},
					{
						id: 2,
						title: '深海传说',
						artist: '海洋之心',
						image: 'https://picsum.photos/id/137/600/400',
						views: 2800,
						likes: 780
					},
					{
						id: 3,
						title: '都市肖像',
						artist: '城市之光',
						image: 'https://picsum.photos/id/1015/600/400',
						views: 4100,
						likes: 920
					},
					{
						id: 4,
						title: '自然奇观',
						artist: '山水之间',
						image: 'https://picsum.photos/id/1024/600/400',
						views: 3500,
						likes: 890
					},
					{
						id: 5,
						title: '古韵今风',
						artist: '建筑大师',
						image: 'https://picsum.photos/id/1043/600/400',
						views: 2900,
						likes: 750
					},
					{
						id: 6,
						title: '未来城市',
						artist: '科技先锋',
						image: 'https://picsum.photos/id/1067/600/400',
						views: 3800,
						likes: 910
					}
				],
				ruleForm: {
					content: '',
					yongtu: '',
				},
				rules: {
					content: [{
						required: true,
						message: '请详细描述您的定制需求',
						trigger: 'blur'
					}],
					yongtu: [{
						required: true,
						message: '请选择用途',
						trigger: 'blur'
					}],
				},
				activeName: '0',
				options: [],
				agreeTerms: true,
				dialogReplyViable: false,
				publishPop: false,
				show: false,
				data: [{
					show: false,
				}, {
					show: false,
				}, {
					show: false,
				}, {
					show: false,
				}, {
					show: false,
				}, {
					show: false,
				}],
			}
		},
		computed: {
			allComment() {
				let total = 0
				if (this.commentInfo.my_count) {
					total = total + this.commentInfo.my_count
				}
				if (this.commentInfo.yb_count) {
					total = total + this.commentInfo.yb_count
				}
				if (this.commentInfo.bmy_count) {
					total = total + this.commentInfo.bmy_count
				}
				return total
			},
		},
		mounted() {
			this.workList()
			this.commentList()
			this.painterDetails()
			this.basicsVipList()
			this.basicsLabelList()
			this.basicsClassifyList()
		},
		methods: {
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response) {
				this.imgList.push(response.data)
			},
			onPageChange(newPage) {
				this.currentPage = newPage
				this.workList()
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsVipList() {
				this.$api.post('/Basics/vip_list', {}).then(res => {
					if (res.code == 1) {
						this.levelOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeFilter(type, value) {
				if (type == 'cid') {
					this.cid = value
				} else if (type == 'yongtu') {
					this.yongtu = value
				} else if (type == 'level') {
					this.level = value
				} else if (type == 'shuxing') {
					this.shuxing = value
				} else if (type == 'px') {
					this.px = value
				}
				this.workList()
			},
			copyLink() {
				const input = document.createElement('textarea')
				input.value = `http://www.daiyuart.com/#/painter-homepage?id=${this.painterInfo.id}`
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功！')
			},
			huaGuanZhu() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/guanzhu', {
						mb_id: this.painterInfo.id
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.painterDetails()
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			painterDetails() {
				this.$api.post('/Other/hua_details', {
					id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						this.painterInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			workList() {
				this.$api.post('/Goods/work_list', {
					id: this.$route.query.id,
					cid: this.cid,
					yongtu: this.yongtu,
					level: this.level,
					shuxing: this.shuxing == '默认' ? '' : this.shuxing,
					px: this.px,
					p: this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						this.workData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			commentList() {
				//1满意 2-般 3不满意
				this.$api.post('/Goods/dz_order_evaluate_list', {
					type: this.activeName == 0 ? '' : this.activeName,
					hs_id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						this.commentData = res.data.list
						this.commentInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//定制用途
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//定制下单
			orderAdd() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/dz_order_add', {
						yongtu: this.ruleForm.yongtu,
						content: this.ruleForm.content,
						img: this.imgList.join(','),
						hs_id: this.$route.query.id,
					}).then(res => {
						if (res.code == 1) {
							this.sucPop = true
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			submit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.agreeTerms) return this.$message.warning('请阅读并同意《用户购买须知协议》')
						this.orderAdd()
					} else {
						return false
					}
				})
			},
			replyComment() {
				this.dialogReplyViable = true
				document.body.style.overflow = 'hidden';
			},
		}
	}
</script>

<style lang="scss" scoped>
	.homepage-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.bgIcon {
		width: 100%
	}

	.painterInfoBox {
		width: 12rem;
		margin: -.46rem auto 0;
	}

	.topInfoBox {
		display: flex;
		justify-content: space-between;

		.avatarNameFansWorkNum {
			display: flex;
			align-items: center;

			.avatar {
				width: 1.8rem;
				height: 1.8rem;
				border-radius: 50%;
				overflow: hidden;
				object-fit: cover;
			}

			.nameFansWorkNum {
				margin-left: .12rem;
				display: flex;
				flex-direction: column;

				.name {
					font-weight: 700;
					font-size: .3rem;
					color: #312C28;
				}

				.fansWorkNum {
					margin-top: .08rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .16rem;
					color: #666666;

					.line {
						margin: 0 .08rem;
						width: .02rem;
						height: .12rem;
						background: #CCCCCC;
					}
				}
			}
		}

		.menuBox {
			display: flex;
			align-items: center;

			.menuItem {
				margin-left: .24rem;
				width: 1.5rem;
				height: .38rem;
				display: flex;
				align-items: center;
				justify-content: center;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: .06rem;
				font-weight: 400;
				font-size: .14rem;
				color: #FFFFFF;
				cursor: pointer;

				img {
					margin-right: .04rem;
					width: .14rem;
					height: .14rem;
				}
			}

			.menuItem:first-child {
				background: #706614;
			}

			.menuItem:last-child {
				background: #E29358;
			}
		}
	}


	.descTitle {
		margin-top: .26rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 500;
		font-size: .16rem;
		color: #1C1C1C;
		line-height: .24rem;

		.rightMenu {
			display: flex;
			align-content: center;

			.rightMenuItem {
				margin-left: .16rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #999999;
				line-height: .2rem;
				cursor: pointer;

				.icon {
					margin-right: .04rem;
					width: .16rem;
					height: .16rem;
				}
			}
		}
	}

	.desc {
		margin-top: .12rem;
		display: flex;
		flex-direction: column;

		.descItem {
			font-weight: 400;
			font-size: .16rem;
			color: #666666;
			line-height: .24rem;
		}
	}

	.rateBox {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		padding: 0 0 .16rem;
		width: 12rem;
		height: 1.50rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.rateItem:last-child {
			.rateTitle {
				margin-top: .16rem;
			}
		}

		.rateItem {
			margin-top: .16rem;
			width: calc(25% - .01rem);
			display: flex;
			flex-direction: column;
			align-items: center;
			font-weight: bold;
			font-size: .32rem;
			color: #E29358;

			.rateTitle {
				margin-top: .08rem;
				font-weight: 400;
				font-size: .14rem;
				color: #1C1C1C;
				line-height: .2rem;
			}

			.rates {
				margin-top: .15rem;
				display: flex;
				align-items: center;

				img {
					margin-right: .06rem;
					width: .18rem;
					height: .18rem;
				}
			}
		}

		.line {
			width: .02rem;
			height: .4rem;
			background: #CCCCCC;
		}
	}

	.naviBarMenu {
		margin: .48rem auto 0;
		display: flex;
		align-items: center;
		border-radius: .08rem;
		border: .01rem solid #E29358;
		overflow: hidden;

		.naviBarItem {
			width: 2.60rem;
			height: .46rem;
			font-size: .16rem;
			color: #252525;
			line-height: .46rem;
			text-align: center;
			cursor: pointer;
		}

		.avtive {
			font-weight: 500;
			background: #E29358;
		}

		.normal {
			font-weight: 400;
			background: #FAFAE9;
		}
	}

	.workList {
		width: 12rem;
		margin: .16rem auto 0;
		display: flex;
		flex-direction: column;
	}

	.filterBox {
		display: flex;
		flex-direction: column;
		width: 12rem;
		border-radius: .12rem;

		.searchBox {
			margin: .24rem auto;
			display: flex;
			align-items: center;
			border-radius: .06rem;
			border: 0.01rem solid #E29358;
			width: 5.9rem;
			height: .4rem;

			input {
				width: 4.9rem;
				height: .38rem;
				margin-left: .12rem;
				padding: 0 0;
				border: none;
				font-weight: 400;
				font-size: .14rem;
			}

			.search {
				width: .88rem;
				height: .4rem;
				background: #E29358;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: 0 .06rem .06rem 0;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .4rem;
				text-align: center;
			}
		}

		.filterTitle {
			font-weight: 500;
			font-size: .14rem;
			color: #000000;
		}

		.filterItem {
			display: flex;
			font-size: .14rem;

			.filterItemTitle {
				margin-top: .16rem;
				height: .28rem;
				line-height: .28rem;
				width: .75rem;
				font-weight: 400;
				color: #000000;
			}

			.filterItemList {
				width: calc(100% - .75rem);
				display: flex;
				flex-wrap: wrap;

				.tip {
					margin-top: .16rem;
					margin-right: .24rem;
					height: .28rem;
					line-height: .28rem;
					font-weight: 400;
					color: #666666;
					cursor: pointer;

					&.active {
						color: #000000;
						padding: 0 .1rem;
						background: #E29358;
						box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
						border-radius: .06rem;
					}
				}
			}
		}
	}

	.officialList {
		width: 12rem;
		display: flex;
		flex-wrap: wrap;

		.officalItem:nth-child(4n) {
			margin-right: 0;
		}
	}

	.customizeBox {
		margin: .32rem auto 0;
		width: 12rem;
		background: #FFFFFF;
		padding: .32rem .32rem .16rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		position: relative;

		.tips {
			display: flex;
			align-items: center;
			font-weight: 500;
			font-size: .14rem;
			color: #312C28;
			line-height: .2rem;
		}

		.reportContent {
			position: relative;

			.textNum {
				position: absolute;
				right: .12rem;
				bottom: .12rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #999999;
				line-height: .2rem;

				span {
					color: #252525;
				}
			}
		}

		.imgList {
			display: flex;
			flex-wrap: wrap;

			.imgItem {
				margin-right: .16rem;
				display: flex;
				width: .86rem;
				height: .86rem;
				border-radius: .04rem;
				overflow: hidden;
				position: relative;

				.delete {
					position: absolute;
					top: .05rem;
					right: .05rem;
					width: .14rem;
					height: .14rem;
					cursor: pointer;
				}

				.imgItemImg {
					width: .86rem;
					height: .86rem;
					object-fit: cover;
				}
			}

			.addImgBox {
				width: .86rem;
				height: .86rem;
				border-radius: .04rem;
				background: #FFFFFF;
				border: 1px solid #EFD8B8;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: .12rem;
				color: #999999;
				cursor: pointer;
				line-height: .18rem;

				.addImg {
					margin-bottom: .08rem;
					width: .27rem;
					height: .23rem;
				}
			}
		}

		::v-deep .el-form {

			&-item:nth-child(2),
			&-item:nth-child(4) {
				align-items: flex-start;

				.el-form-item__label {
					margin-top: .16rem;
				}
			}

			&-item {
				display: flex;
				align-items: center;
				margin-bottom: .16rem;

				&__label {
					width: .88rem;
					font-size: .14rem;
					color: #252525;
					line-height: .2rem;
				}

				&__content {

					.el-textarea {
						&__inner {
							width: 10.4rem;
							height: 1.6rem;
							background: #FFFFFF;
							border-radius: .04rem;
							border: .01rem solid #EFD8B8;
							font-weight: 400;
							font-size: .14rem;
							color: #252525;
						}
					}

					.el-input {

						&__inner {
							width: 4.1rem;
							height: .52rem;
							font-weight: 400;
							font-size: .14rem;
							color: #252525;
							line-height: .52rem;
							border: .01rem solid #EFD8B8;
						}

						&__icon {
							font-size: .14rem;
						}
					}
				}
			}
		}
	}

	.userAgreementSubmit {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		position: absolute;
		right: .32rem;
		bottom: .56rem;

		.agreement-container {
			margin: 0.16rem 0 0 1.38rem;
			font-size: 0.14rem;
		}

		.agreement-label {
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.agreement-checkbox {
			margin-right: 0.08rem;
			width: .16rem;
			height: .16rem;
			cursor: pointer;
		}

		.agreement-text {
			font-weight: 400;
			color: #333333;
			margin-right: 0.04rem;
		}

		.agreement-link {
			font-weight: 400;
			color: #E29358;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}

		// 按钮样式
		.register-btn {
			margin-top: .16rem;
			width: 1.30rem;
			height: .36rem;
			background: #E29358;
			padding: 0 0;
			border: none;
			border-radius: 0.04rem;
			font-size: 0.14rem;
			color: #252525;
			font-weight: 400;
			line-height: .36rem;
			cursor: pointer;
			transition: background-color 0.3s ease;

			&:hover {
				background: #D17F3A;
			}
		}
	}

	.tabsBox {
		width: 12rem;


		::v-deep .el-tabs {

			&__header {
				margin: 0 0 .16rem;
			}

			&__active-bar {
				background-color: #6B3503 !important;
			}

			&__item {
				height: .54rem;
				padding: 0 .2rem;
				font-weight: 400;
				font-size: .16rem;
				color: #6B3503 !important;
				line-height: .54rem;

				&:hover {
					color: #6B3503 !important;
				}
			}

			&__nav-wrap::after {
				height: .01rem;
			}

			.is-active {
				font-weight: 500;
				color: #6B3503 !important;
			}
		}
	}

	.commentBoxList {
		width: 12rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.comment:last-child {
			.commentContentBox {
				border-bottom: none;
			}
		}

		.comment {
			// margin-top: .24rem;
			display: flex;
			flex-direction: column;
			width: 12rem;
			background: #FFFFFF;
			// box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			// border-radius: .12rem;
			padding: .32rem .48rem .0rem .32rem;

			.userInfoBox {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.userInfo {
					display: flex;
					align-items: center;

					.avatar {
						width: .68rem;
						height: .68rem;
						border-radius: 50%;
						overflow: hidden;
						object-fit: cover;
					}

					.nameTimeIdentity {
						margin-left: .16rem;
						display: flex;
						flex-direction: column;

						.nameBox {
							display: flex;
							align-items: center;
							font-weight: bold;
							font-size: .18rem;
							color: #312C28;

							.toTop {
								margin-left: .08rem;
								height: .2rem;
								display: flex;
								align-items: center;
								justify-content: center;
								padding: 0rem .08rem;
								border: .01rem solid #F56C6C;
								border-radius: .1rem;
								font-weight: 400;
								font-size: .12rem;
								color: #F56C6C;

								.toTopIcon {
									margin-right: .02rem;
									width: .1rem;
									height: .1rem;
								}
							}
						}

						.timeIdentity {
							margin-top: .08rem;
							font-weight: 400;
							font-size: .14rem;
							color: #999999;

							.identity {
								margin-left: .08rem;
							}
						}
					}
				}

				.reportBox {
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .12rem;
					color: #999999;

					.reportIcon {
						width: .14rem;
						height: .14rem;
						margin-right: .04rem;
					}
				}
			}

			.commentContentBox {
				margin: .16rem 0 0 .84rem;
				display: flex;
				flex-direction: column;
				padding-bottom: .24rem;
				border-bottom: .01rem solid #CCCCCC;

				.contentText {
					font-weight: 400;
					font-size: .16rem;
					color: #312C28;
					line-height: .24rem;
				}

				.imgList {
					margin-top: .12rem;
					width: 100%;
					display: flex;
					flex-wrap: wrap;

					.imgItem {
						margin-top: .12rem;
						margin-right: .12rem;
						width: 1.54rem;
						height: 2.06rem;
						border-radius: .08rem;
					}
				}
			}

			.commentMenuBox {
				margin: .24rem .48rem 0 .84rem;
				display: flex;
				align-items: center;

				.commentMenuItem {
					width: .72rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #666666;

					.icon {
						margin-right: .08rem;
						width: .16rem;
						height: .16rem;
					}
				}
			}

			.commentCommentBox {
				margin-top: .24rem;
				display: flex;
				flex-direction: column;
				padding: 0 0 .24rem .68rem;
				border-top: .01rem solid #CCCCCC;
				border-bottom: .01rem solid #CCCCCC;

				.commentComment {
					margin-top: .24rem;
					display: flex;
					flex-direction: column;

					.commentCommentUserInfoBox {
						display: flex;
						align-items: center;

						.commentCommentUserInfo {
							width: 100%;
							display: flex;
							align-items: center;

							.commentCommentUserInfoavatar {
								width: .36rem;
								height: .36rem;
								border-radius: 50%;
								object-fit: cover;
							}

							.commentCommentUserInfoNameTime {
								width: 100%;
								display: flex;
								flex-direction: column;
								margin-left: .08rem;

								.commentCommentUserInfoName {
									font-weight: 500;
									font-size: .12rem;
									color: #312C28;
									line-height: .18rem;
								}

								.commentCommentUserInfoTimeReply {
									width: 100%;
									margin-top: .02rem;
									display: flex;
									align-items: center;
									justify-content: space-between;
									font-weight: 400;
									font-size: .12rem;
									color: #999999;
									line-height: .18rem;

									.reply {
										color: #E29358;
										cursor: pointer;
									}
								}
							}
						}
					}

					.commentCommentContentBox {
						margin: .12rem 0 0 .44rem;
						font-weight: 400;
						font-size: .14rem;
						color: #312C28;
					}

					.lastCommentList {
						margin: .2rem 0 0 .44rem;
						padding-left: .16rem;
						display: flex;
						flex-direction: column;
						border-left: .01rem solid #CCCCCC;

						.lastComment:first-child {
							margin-top: 0;
						}

						.lastComment {
							margin-top: .12rem;
							display: flex;
							flex-direction: column;

							.nameLastCommentContent {
								display: flex;
								align-items: center;
								font-weight: 400;
								font-size: .14rem;
								color: #E29358;

								.lastCommentContent {
									color: #312C28;
								}
							}

							.lastCommentContentTime {
								font-weight: 400;
								font-size: .12rem;
								color: #999999;
							}
						}

						.moreBox {
							margin-top: .12rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #E29358;
							cursor: pointer;

							.downArrow {
								width: .06rem;
								height: .04rem;
								margin-left: .02rem;
							}
						}
					}
				}
			}
		}

		.lookAll {
			margin: .24rem auto 0;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #666666;
			cursor: pointer;

			.downTwoArrow {
				width: .12rem;
				height: .06rem;
				margin-left: .06rem;
			}
		}
	}

	li {
		margin-bottom: 0;
	}
</style>